import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export var combineRefs = function combineRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) refs[_key] = arguments[_key];
  return function (node) {
    refs.forEach(function (ref) {
      ref && ("function" != typeof ref ? ref.current = node : ref(node));
    });
  };
};